"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import AddRulesLeftPage from "@/views/managements/safemanager/rulespage/AddRulesLeftPage.vue";
import AddRulesRightPage from "@/views/managements/safemanager/rulespage/AddRulesRightPage.vue";
import AddRulesChooseShopsDialog from "@/views/managements/safemanager/rulespage/AddRulesChooseShopsDialog.vue";
import AddRulesChooseMembersDialog from "@/views/managements/safemanager/rulespage/AddRulesChooseMembersDialog.vue";
import i18n from "@/lang";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import API from "@ym-framework/api-utils";
export class AddRulesController extends UiFormController {
  constructor() {
    super(...arguments);
    this.rulesName = "";
    // 规则描述
    this.rulesDescription = "";
    this.rulesSelector = "";
    this.rulesSelectorMembers = [];
    this.rulesEnvironment = "all";
    this.rulesEnvironmentShops = [];
    this.rulesScope = "all";
    //=========选择所有网页的参数===============
    //复制
    this.rulesCopy = "ALLOW_AND_RECORD";
    //文件上传
    this.rulesFileUpload = "ALLOW_AND_RECORD";
    //文件下载
    this.rulesFileDownload = "ALLOW_AND_RECORD";
    //打印
    this.rulesPrint = "ALLOW_AND_RECORD";
    //开发者模式
    this.rulesDeveloperMode = "ALLOW_AND_RECORD";
    //查看密码框
    this.rulesViewPassword = "RESTRICTION";
    this.rulesInterceptStrategy = "blacklist";
    //暂时存储名单列表的Map，提交时需要重新处理结构类型
    this.webpageResourceAccessRules = [];
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_rules.form.rules_name_tip"),
      trigger: "blur"
    }
  ])
], AddRulesController.prototype, "rulesName", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_rules.form.rules_selector_tip"),
      trigger: "blur"
    }
  ])
], AddRulesController.prototype, "rulesSelector", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_rules.form.rules_environment_tip"),
      trigger: "blur"
    }
  ])
], AddRulesController.prototype, "rulesEnvironment", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_rules.form.rules_scope_tip"),
      trigger: "blur"
    }
  ])
], AddRulesController.prototype, "rulesScope", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_rules.form.rules_intercept_strategy_tip"),
      trigger: "blur"
    }
  ])
], AddRulesController.prototype, "rulesInterceptStrategy", 2);
let AddRules = class extends Vue {
  constructor() {
    super(...arguments);
    this.formController = new AddRulesController();
    this.submitLoading = false;
    this.editMode = false;
    this.editFormId = "";
    this.pageLoading = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.pageLoading = true;
      if (this.$route.query.hasOwnProperty("id")) {
        this.editMode = true;
        this.editFormId = this.$route.query.id;
        yield this.getEditFormData();
      } else {
        this.editMode = false;
      }
      this.pageLoading = false;
    });
  }
  getEditFormData() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v1/webpage-access-rules/${this.editFormId}`
        );
        let editFormData = response.data;
        this.formController.rulesName = editFormData.name;
        this.formController.rulesDescription = editFormData.description;
        this.formController.rulesSelector = editFormData.effectiveMember.memberType;
        let arr = [];
        for (let item of editFormData.effectiveMember.member) {
          let data = {
            id: item.memberId,
            label: item.memberName
          };
          arr.push(data);
        }
        this.formController.rulesSelectorMembers = arr;
        this.formController.rulesEnvironment = editFormData.effectiveShop.shopType;
        let shops = editFormData.effectiveShop.shop;
        let shop_arr = [];
        for (let item of shops) {
          let data = {
            id: item.shopId,
            name: item.shopName
          };
          shop_arr.push(data);
        }
        this.formController.rulesEnvironmentShops = shop_arr;
        this.formController.rulesScope = editFormData.accessRule.effectiveScope;
        if (editFormData.accessRule.effectiveScope === "all") {
          let copyData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "duplicate" }
          );
          this.formController.rulesCopy = copyData.power;
          let uploadData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "file_upload" }
          );
          this.formController.rulesFileUpload = uploadData.power;
          let downloadData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "file_download" }
          );
          this.formController.rulesFileDownload = downloadData.power;
          let printData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "print" }
          );
          this.formController.rulesPrint = printData.power;
          let developData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "developer_mode" }
          );
          this.formController.rulesDeveloperMode = developData.power;
          let viewPasswordData = _.find(
            editFormData.accessRule.accessRule.pageAccessRules,
            { code: "view_password_box" }
          );
          this.formController.rulesViewPassword = viewPasswordData.power;
        }
        if (editFormData.accessRule.effectiveScope === "web") {
          this.formController.rulesInterceptStrategy = editFormData.accessRule.accessRule.intercept;
          let group_arr = editFormData.accessRule.accessRule.webpageResourceGroupAccessRules;
          let rulesListArr = [];
          let injectSelectedItems = [];
          for (let arr2 of group_arr) {
            let parentGroup = _.find(arr2.groups, { parentId: "root" });
            let group = _.filter(
              arr2.groups,
              (item) => item.parentId !== "root"
            )[0];
            let rule_item_arr = [];
            for (let accessRuleItem of arr2.webResourceAccessRules) {
              let item = {
                id: accessRuleItem.id,
                description: "",
                model: "general",
                name: accessRuleItem.name,
                type: "",
                url: accessRuleItem.url,
                xpathNum: 0,
                group: {
                  model: group.model,
                  id: group.id,
                  name: group.name,
                  parent: {
                    model: parentGroup.model,
                    id: parentGroup.id,
                    name: parentGroup.name,
                    parent: null
                  }
                },
                rulesAccess: true,
                recordAccess: true,
                accessRules: accessRuleItem.pageAccessRules,
                selectedElementIds: _.map(accessRuleItem.elements, "id")
              };
              let selectedItem = {
                model: "general",
                id: accessRuleItem.id,
                name: accessRuleItem.name,
                description: "",
                type: "",
                url: accessRuleItem.url,
                xpathNum: 0,
                group: {
                  model: group.model,
                  id: group.id,
                  name: group.name,
                  parent: {
                    model: parentGroup.model,
                    id: parentGroup.id,
                    name: parentGroup.name,
                    parent: null
                  }
                }
              };
              injectSelectedItems.push(selectedItem);
              if (editFormData.accessRule.accessRule.intercept === "whitelist") {
                if (accessRuleItem.access.includes("RECORD_ACCESS_BEHAVIOR")) {
                  item.recordAccess = true;
                } else {
                  item.recordAccess = false;
                }
              }
              if (editFormData.accessRule.accessRule.intercept === "blacklist") {
                if (accessRuleItem.access.includes("RESTRICTION")) {
                  item.rulesAccess = true;
                } else {
                  item.rulesAccess = false;
                }
                if (accessRuleItem.access.includes("RECORD_ACCESS_BEHAVIOR")) {
                  item.recordAccess = true;
                } else {
                  item.recordAccess = false;
                }
              }
              rule_item_arr.push(item);
            }
            let data = {
              name: parentGroup.name + "-" + group.name,
              id: group.id,
              arr: rule_item_arr
            };
            rulesListArr.push(data);
          }
          this._rules_right_page.setSelectedDatas(injectSelectedItems);
          this.formController.webpageResourceAccessRules = rulesListArr;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.push({ path: "/security", query: { tab: "access_rule" } });
  }
  helpButton() {
    window.open("https://www.kuajingvs.com/help2/24990", "__blank");
  }
  openChooseMembers() {
    if (this.formController.rulesSelectorMembers.length > 0) {
      this._add_rules_choose_members_dialog.open(
        this.formController.rulesSelectorMembers
      );
    } else {
      this._add_rules_choose_members_dialog.open();
    }
  }
  openChooseShops() {
    if (this.formController.rulesEnvironmentShops.length > 0) {
      this._add_rules_choose_shops_dialog.open(
        this.formController.rulesEnvironmentShops
      );
    } else {
      this._add_rules_choose_shops_dialog.open();
    }
  }
  changeEnvShops(data) {
    console.log(data);
    this.formController.rulesEnvironment = data.changeMode;
    if (data.changeMode === "shops") {
      this.formController.rulesEnvironmentShops = data.selectedShops;
    }
  }
  changeMembers(data) {
    this.formController.rulesSelectorMembers = data.datas;
  }
  submitForm() {
    return __async(this, null, function* () {
      try {
        yield this._rulesForm._form.validate();
        let ids = [];
        if (this.formController.rulesSelectorMembers.length > 0) {
          for (let item of this.formController.rulesSelectorMembers) {
            ids.push(item.id);
          }
        }
        let formData = __spreadValues({
          name: this.formController.rulesName,
          description: this.formController.rulesDescription,
          effectiveMember: __spreadValues({
            type: this.formController.rulesSelector
          }, (() => {
            if (this.formController.rulesSelectorMembers.length > 0) {
              let ids2 = [];
              for (let item of this.formController.rulesSelectorMembers) {
                ids2.push(item.id);
              }
              return {
                ids: ids2
              };
            }
          })()),
          effectiveShop: __spreadValues({
            type: this.formController.rulesEnvironment
          }, (() => {
            if (this.formController.rulesEnvironmentShops.length > 0) {
              let shops = [];
              for (let item of this.formController.rulesEnvironmentShops) {
                if (item.hasOwnProperty("shopOldId")) {
                  shops.push(item.shopOldId);
                } else {
                  shops.push(item.id);
                }
              }
              return {
                ids: shops
              };
            } else {
              return {
                ids: []
              };
            }
          })()),
          effectiveScope: this.formController.rulesScope
        }, (() => {
          if (this.formController.rulesScope === "all") {
            let arr = [];
            let data_duplicate = {
              code: "duplicate",
              power: this.formController.rulesCopy
            };
            arr.push(data_duplicate);
            let data_file_upload = {
              code: "file_upload",
              power: this.formController.rulesFileUpload
            };
            arr.push(data_file_upload);
            let data_file_download = {
              code: "file_download",
              power: this.formController.rulesFileDownload
            };
            arr.push(data_file_download);
            let data_print = {
              code: "print",
              power: this.formController.rulesPrint
            };
            arr.push(data_print);
            let data_developer_mode = {
              code: "developer_mode",
              power: this.formController.rulesDeveloperMode
            };
            arr.push(data_developer_mode);
            let data_view_password_box = {
              code: "view_password_box",
              power: this.formController.rulesViewPassword
            };
            arr.push(data_view_password_box);
            console.log(arr);
            return {
              accessRule: {
                model: "allWebpageAccessRule",
                pageAccessRules: arr
              }
            };
          }
          if (this.formController.rulesScope === "web") {
            let real_rules_arr = [];
            for (let item of this.formController.webpageResourceAccessRules) {
              for (let ruleItem of item.arr) {
                let access_arr = [];
                if (this.formController.rulesInterceptStrategy === "blacklist") {
                  if (ruleItem.rulesAccess === true) {
                    access_arr.push("RESTRICTION");
                  }
                  if (ruleItem.recordAccess === true) {
                    access_arr.push("RECORD_ACCESS_BEHAVIOR");
                  }
                } else if (this.formController.rulesInterceptStrategy === "whitelist") {
                  access_arr.push("ALLOW");
                  if (ruleItem.recordAccess === true) {
                    access_arr.push("RECORD_ACCESS_BEHAVIOR");
                  }
                }
                let data = {
                  id: ruleItem.id,
                  access: access_arr,
                  pageAccessRules: ruleItem.accessRules,
                  elementIds: ruleItem.selectedElementIds
                };
                real_rules_arr.push(data);
              }
            }
            return {
              accessRule: {
                model: "specifyWebPageAccessRule",
                intercept: this.formController.rulesInterceptStrategy,
                webpageResourceAccessRules: real_rules_arr
              }
            };
          }
        })());
        if (this.formController.rulesScope === "web" && (!formData.accessRule.webpageResourceAccessRules || formData.accessRule.webpageResourceAccessRules.length === 0)) {
          this.$message.error(
            this.$t("add_rules.form.black_list_empty_content")
          );
          return;
        }
        if (this.editMode === false) {
          yield API.post(`api://base.auth/api/v1/webpage-access-rules`, formData);
          this.$message.success(
            this.$i18n.t("add_rules.form.add_rules_success")
          );
          this.$router.push({ path: "/security", query: { tab: "access_rule" } });
        } else {
          formData["model"] = "access.rule";
          yield API.put(
            `api://base.auth/api/v1/webpage-access-rules/${this.editFormId}`,
            formData
          );
          this.$message.success(
            this.$i18n.t("add_rules.form.edit_rules_success")
          );
          this.$router.push({ path: "/security", query: { tab: "access_rule" } });
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("addRulesRightPage")
], AddRules.prototype, "_rules_right_page", 2);
__decorateClass([
  Ref("rulesForm")
], AddRules.prototype, "_rulesForm", 2);
__decorateClass([
  Ref("add_rules_choose_shops_dialog")
], AddRules.prototype, "_add_rules_choose_shops_dialog", 2);
__decorateClass([
  Ref("add_rules_choose_members_dialog")
], AddRules.prototype, "_add_rules_choose_members_dialog", 2);
AddRules = __decorateClass([
  Component({
    components: {
      AddRulesLeftPage,
      AddRulesRightPage,
      UiForm,
      AddRulesChooseShopsDialog,
      AddRulesChooseMembersDialog
    }
  })
], AddRules);
export {
  AddRules as default
};
